import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  private subject = new Subject<boolean>();
  constructor() { }

  connect(): Observable<boolean> {
    return this.subject.asObservable();
  }

  show() {
    console.log('SpinnerService: show');
    this.subject.next(true);
  }

  hide() {
    console.log('SpinnerService: hide');
    this.subject.next(false);
  }

}
